export default __webpack_public_path__ + "static/media/emptyCoupon.3d540509.png";